module.exports = __webpack_public_path__ + "img/logo_dark.cb4d1e49.png";